import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Parrot from "./components/Parrot";
import Swan from "./components/Swan";
import Eagle from "./components/Eagle";
import Peacock from "./components/Peacock";
import Owl from "./components/Owl";
import Flamingo from "./components/Flamingo";
import SignIn from "./components/SignIn";
import Login from "./components/Login";
import Service1 from "./components/Service1";
import Payment from "./components/Payment";
import Service2 from "./components/Service2";
import Service3 from "./components/Service3";
import Service3Payment from "./components/Service3Payment";

function App() {
  return (
    <HashRouter>
      <Header />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/parrot" element={<Parrot />} />
        <Route path="/swan" element={<Swan />} />
        <Route path="/eagle" element={<Eagle />} />
        <Route path="/peacock" element={<Peacock />} />
        <Route path="/owl" element={<Owl />} />
        <Route path="/flamingo" element={<Flamingo />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/login" element={<Login />} />
        <Route path="/service1" element={<Service1 />} />
        <Route path="/service2" element={<Service2 />} />
        <Route path="/service3" element={<Service3 />} />
        <Route path="/service3-payment" element={<Service3Payment />} />
        <Route path="/payment" element={<Payment />} />
      </Routes>

      <Footer />
    </HashRouter>
  );
}

export default App;
